<template>
  <el-dialog title='提交开票' :visible.sync='invoicingVisible' width='1050px' @close='invoicingClose'
             center :close-on-click-modal='false'>
    <div class='p20' v-loading='invoicingLoading'>
      <el-form :model='invoicingData' label-width='120px' ref='ruleForm2' size='medium'>
        <div-border label='开票信息' divStyle='margin-top: 10px;padding-top:15px;'>
          <el-row>
            <el-col :span='12'>
              <el-form-item label='购买方名称：' label-width='150px' style='margin-bottom: 0'>
                {{ invoicingData.purchaserName || '无' }}
              </el-form-item>
            </el-col>
            <el-col :span='12'>
              <el-form-item label='销售方名称：' label-width='150px' style='margin-bottom: 0'>
                {{ invoicingData.sellerName || '无' }}
              </el-form-item>
            </el-col>
            <el-col :span='12'>
              <el-form-item label='购买纳税人识别号：' label-width='150px' style='margin-bottom: 0'>
                {{ invoicingData.purchaserDentificaNumber || '无' }}
              </el-form-item>
            </el-col>
            <el-col :span='12'>
              <el-form-item label='销售纳税人识别号：' label-width='150px' style='margin-bottom: 0'>
                {{ invoicingData.sellerDentificaNumber || '无' }}
              </el-form-item>
            </el-col>
            <el-col :span='12'>
              <el-form-item label='购买方地址：' label-width='150px' style='margin-bottom: 0'>
                {{ invoicingData.purchaserAddress || '无' }}
              </el-form-item>
            </el-col>
            <el-col :span='12'>
              <el-form-item label='销售方地址：' label-width='150px' style='margin-bottom: 0'>
                {{ invoicingData.sellerAddress || '无' }}
              </el-form-item>
            </el-col>
            <el-col :span='12'>
              <el-form-item label='购买方电话：' label-width='150px' style='margin-bottom: 0'>
                {{ invoicingData.purchaserTel || '无' }}
              </el-form-item>
            </el-col>
            <el-col :span='12'>
              <el-form-item label='销售方电话：' label-width='150px' style='margin-bottom: 0'>
                {{ invoicingData.sellerTel || '无' }}
              </el-form-item>
            </el-col>
            <el-col :span='12'>
              <el-form-item label='购买方开户行：' label-width='150px' style='margin-bottom: 0'>
                {{ invoicingData.purchaserBankDeposit || '无' }}
              </el-form-item>
            </el-col>
            <el-col :span='12'>
              <el-form-item label='销售方开户行：' label-width='150px' style='margin-bottom: 0'>
                {{ invoicingData.sellerBankDeposit || '无' }}
              </el-form-item>
            </el-col>
            <el-col :span='12'>
              <el-form-item label='购买方银行账号：' label-width='150px' style='margin-bottom: 0'>
                {{ invoicingData.purchaserBankAccount || '无' }}
              </el-form-item>
            </el-col>
            <el-col :span='12'>
              <el-form-item label='销售方银行账号：' label-width='150px' style='margin-bottom: 0'>
                {{ invoicingData.sellerBankAccount || '无' }}
              </el-form-item>
            </el-col>
          </el-row>
          <!--          <el-form-item label='是否开具销售清单：' label-width='150px' prop='type'>
                      <el-radio v-model='isSalesList' :label='0'>否</el-radio>
                      <el-radio v-model='isSalesList' :label='1'>是</el-radio>
                    </el-form-item>-->

          <div>
            <el-row type='flex' justify='space-between' align='middle'
                    style='margin-bottom: 10px;'>
              <el-col :span='12'>
                <!--                <el-form-item label='服务名称：' prop='serviceName' label-width='150px'>
                                  <el-select v-model='invoicingData.serviceName' placeholder='请选择'>
                                    <el-option
                                      v-for='(item, index) in serviceNameOptions'
                                      :key='index'
                                      :label='item.classaName'
                                      :value='item.classaName' />
                                  </el-select>
                                </el-form-item>-->
              </el-col>
              <el-col :span='12'>
                <div style='float: right'>
                  开票含税合计金额：{{ invoicingData.taxPrice || 0 }}元
                  开票不含税合计金额：{{ invoicingData.price || 0 }}元
                </div>
              </el-col>
            </el-row>
          </div>
        </div-border>
        <div class='btnContainer'>
          <el-button size='medium' class='searchBtn' @click='invoicingConfirmClick'>
            确定
          </el-button>
          <el-button size='medium' class='resetBtn' @click='invoicingClose'>关闭</el-button>
        </div>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
  import DivBorder from '@/components/divBorder';

  export default {
    name: 'submitBilling',
    components: { DivBorder },
    data() {
      return {
        invoicingVisible: false,
        invoicingLoading: false,
        invoicingData: {},
      };
    },
    methods: {
      invoicingOpen(data) {
        this.invoicingData = data;
        this.invoicingVisible = true;
      },
      invoicingClose() {
        this.invoicingVisible = false;
      },
      invoicingConfirmClick() {
        this.invoicingLoading = true;
        this.$emit('submitBilling', this.invoicingData);
      },
    },
  };
</script>

<style scoped>

</style>
